<template>
  <div class="grade-history-item">
    <loading :show="loading" small>
      <span v-if="scores.length == 0 && !loading">
        Esse módulo não possui avaliação respondida!
      </span>
      <div v-if="scores.length" class="table">
        <span class="table-column-name">Avaliação</span>
        <span class="table-column-name">Data</span>
        <span class="table-column-name">Nota</span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div v-for="(score, i) in scores" :key="`score-grade-history-${i}`">
        <div class="table">
          <span class="table-column-name"></span>
          <span class="table-column-name"></span>
          <span class="table-column-name"></span>
          <span>{{ score.quiz.title }}</span>
          <span>{{ format(score.started_at) }}</span>
          <span>{{ score.score }}%</span>
        </div>
        <div
          class="table-mobile py-3 d-lg-none"
          :class="{ last: i == scores.length - 1 }"
        >
          <span
            ><span class="table-column-name mr-2">Avaliação:</span>
            {{ score.quiz.title }}</span
          >
          <span
            ><span class="table-column-name mr-2">Data:</span>
            {{ format(score.started_at) }}</span
          >
          <span
            ><span class="table-column-name mr-2">Nota:</span>
            {{ score.score }}%</span
          >
        </div>
      </div>
    </loading>
  </div>
</template>

<script>
export default {
  props: {
    moduleId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      loading: false,
      scores: []
    };
  },
  methods: {
    format(date) {
      return new Date(date).toLocaleDateString();
    }
  },
  mounted() {
    this.$root.$on("bv::collapse::state", (collapseId, isJustShown) => {
      if (collapseId === this.moduleId && isJustShown) {
        this.loading = true;
        this.$store
          .dispatch("modules/getGradeHistory", {
            module_id: this.moduleId
          })
          .then(response => {
            this.scores = response.results;
          })
          .finally(() => {
            this.loading = false;
          });
      }
    });
  }
};
</script>
<style lang="scss" scoped>
.grade-history-item {
  .table {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    @media screen and (max-width: 991px) {
      display: none;
    }
  }
  .table-mobile {
    display: flex;
    flex-direction: column;

    &.last {
      border-bottom: none;
    }
  }
}
</style>
